import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!window.fbq) {
        window.fbq = function () {
          window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = window.fbq;
        window.fbq.push = window.fbq;
        window.fbq.loaded = true;
        window.fbq.version = '2.0';
        window.fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        window.fbq('init', '1683619509332321');
        window.fbq('track', 'PageView');
      }
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, []);
  return null;
}